var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible
    ? _c(
        "div",
        {
          directives: [
            {
              name: "click-outside",
              rawName: "v-click-outside",
              value: {
                exclude: [],
                handler: _vm.onClickOutside,
              },
              expression:
                "{\n        exclude: [],\n        handler: onClickOutside\n    }",
            },
          ],
          staticClass: "form-item select",
          class: [
            _vm.item.data.htmloptions,
            _vm.isInvalid ? "is-invalid" : "",
            { disabled: _vm.item.data.disabled },
          ],
        },
        [
          _c(
            "div",
            { class: ["select__wrapper", { "float-label": _vm.floatLabel }] },
            [
              _c(
                "button",
                {
                  staticClass: "select",
                  attrs: { type: "button" },
                  on: { click: _vm.toggleOptions },
                },
                [_c("span", [_vm._v(" " + _vm._s(_vm.selectedOption.label))])]
              ),
              _vm._v(" "),
              _vm.showOptions
                ? _c("div", { staticClass: "select__options" }, [
                    _c(
                      "ul",
                      _vm._l(_vm.answerOptions, function (answer) {
                        return _c(
                          "li",
                          {
                            key: answer.id,
                            on: {
                              click: function ($event) {
                                return _vm.setOption(answer)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(answer.label) +
                                "\n                "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("i", { staticClass: "icon-form-arrow" }),
            ]
          ),
          _vm._v(" "),
          _c("Label", {
            attrs: {
              item: _vm.item,
              "is-invalid": _vm.isInvalid,
              "error-message": _vm.errorMessage,
            },
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.selectedOption.value,
                expression: "selectedOption.value",
              },
            ],
            attrs: { type: "hidden", name: _vm.item.data.id },
            domProps: { value: _vm.selectedOption.value },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.selectedOption, "value", $event.target.value)
              },
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }